module.exports = __webpack_public_path__ + "img/app_logo.71faff64.jpg";